import React from 'react';

import { Form, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'segments/hooks';
import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { CoachesSelector } from 'features/coaches';
import { AddUserToCourtBookingParams, selectActiveBookingDetail, useAddUserToCourtBookingMutation } from 'features/courtsBooking';
import { ProductsSelector } from 'features/products/components/ProductsSelector';
import { SelectUsers } from 'features/users';

type FormData = AddUserToCourtBookingParams
interface Props {
  handleCancel: () => void;
}

export const AddUserToBooking = ({ handleCancel }: Props) => {
  const { t } = useTranslation();

  const bookingDetail = useAppSelector(selectActiveBookingDetail);
  const [form] = Form.useForm<FormData>();

  const [createBooking, { isSuccess, isError, isLoading, error }] = useAddUserToCourtBookingMutation();

  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  if (bookingDetail === null) {
    return;
  }

  const bookingType = bookingDetail.bookingType;
  const onFinish = (values: AddUserToCourtBookingParams) => {
    createBooking({
      ...values,
      bookingId: bookingDetail.bookingId,
      customCourtPrice: 0
    });
  };

  const modalTittle =
    `${t('courts.title.add-user-booking')}`;
  return (
    <Modal
      title={modalTittle}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
      >
        <SelectUsers oneSelectMode allowQuickCreate formProps={{ rules: [{ required: true, message: 'Выберите клиента' }] }} />
        {
          bookingType !== 'groupe' && (
            <>
              <CoachesSelector oneSelectMode />
              <ProductsSelector<FormData> form={form} />
              <InputStr type='customCoachPrice' />
            </>
          )
        }
        <SubmiteButton submiteText={t('add')} isLoading={isLoading} />
      </Form>
    </Modal >
  );
};
